function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 262,
    height: 149,
    viewBox: "0 0 262 149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20519"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 4561",
    style: {
      fill: "#fff",
      stroke: "#e0e0df",
      strokeWidth: ".5px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 149,
    rx: 10,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 261.5,
    height: 148.5,
    rx: 9.75,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.515 20.612H25.193V2.29a2.29 2.29 0 0 0-4.581 0v18.322H2.29a2.29 2.29 0 0 0 0 4.581h18.322v18.322a2.29 2.29 0 1 0 4.581 0V25.193h18.322a2.29 2.29 0 1 0 0-4.581zm0 0",
    transform: "translate(108.097 51.597)",
    style: {
      fill: "#7c7c7c",
      stroke: "#7c7c7c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload2);
export default __webpack_public_path__ + "static/media/upload-2.478359386455a4a48543d3788d43b8fe.svg";
export { ForwardRef as ReactComponent };